<template>
  <product-form :value="product" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="default" type="submit" class="btn btn-link" @click="goToVariants"><i class="icon-color-sampler position-left"></i>Gérer les déclinaisons</form-button>
      <form-button kind="submit" type="submit" @click="goToProducts">Enregistrer</form-button>
      <form-button kind="delete" @click="remove">Supprimer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </product-form>
</template>

<script>
import ProductForm from "./ProductForm.vue";

import ProductDetailQuery from "./graphql/ProductDetailQuery.gql";
import ProductUpdateMutation from "./graphql/ProductUpdateMutation.gql";
import ProductRemoveMutation from "./graphql/ProductRemoveMutation.gql";

export default {
  components: {
    ProductForm
  },
  data() {
    return {
      product: null,
      toVariants: false,
    };
  },
  apollo: {
    product: {
      query: ProductDetailQuery,
      skip() {
        return !this.$route.params.id;
      },
      variables() {
        return this.$route.params;
      }
    }
  },
  methods: {
    goToVariants() {
      this.toVariants = true;
    },
    goToProducts() {
      this.toVariants = false;
    },
    async save(data) {
      try {
        const {data: {productUpdate: product}} = await this.$apollo.mutate({
          mutation: ProductUpdateMutation,
          variables: {
            id: this.product.id,
            data
          }
        });
        this.$store.dispatch(
          "addNotificationSuccess",
          `Le produit a été mis à jour !`
        );
        this.$router.push(this.toVariants? {name: 'product/variants', params: {id: product.id} }: {name: 'products'});
      } catch (err) {
        if (err.message.match(/duplicate/)) {
          return this.$store.dispatch(
            "addNotificationError",
            `L'alias est déjà utilisé par un autre produit !`
          );
        }
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    async remove() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: ProductRemoveMutation,
          variables: {
            id: this.product.id
          }
        });
        if (data.result) {
          this.$store.dispatch(
            "addNotificationSuccess",
            `La produit a été supprimé`
          );
          this.$router.push({ name: "products" });
        } else {
          this.$store.dispatch(
            "addNotificationError",
            `Le produit n'a pas été supprimé`
          );
        }
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/products/ProductEdit.vue